import React, { useState } from 'react';
import { ChevronRightIcon, ChevronDownIcon, PlusIcon } from '../utils/icons';

const BudgetSidebar = ({
  categories = [], 
  activeCategory, 
  onSelectCategory,
  onCreateNew
}) => {
  const [expanded, setExpanded] = useState(true);

  return (
    <aside className="w-64 bg-white border-r border-gray-200 h-full flex flex-col">
      {/* Collapsible Header */}
      <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100 cursor-pointer" onClick={() => setExpanded(e => !e)}>
        <h3 className="text-sm font-semibold text-gray-700">Categories</h3>
        {expanded ? <ChevronDownIcon className="h-5 w-5 text-gray-500" /> : <ChevronRightIcon className="h-5 w-5 text-gray-500" />}
      </div>
      {/* Categories List */}
      {expanded && (
        <nav className="flex-1 overflow-y-auto px-2 py-2">
          {categories.map((cat) => (
            <button
              key={cat.id}
              className={`w-full flex justify-between items-center px-3 py-2 rounded-md text-sm mb-1 transition font-medium ${activeCategory === cat.id ? 'bg-indigo-100 text-indigo-700' : 'text-gray-700 hover:bg-gray-100'}`}
              onClick={() => onSelectCategory(cat.id)}
            >
              <span className="truncate">{cat.name}</span>
              <span className="ml-2 text-xs bg-gray-200 rounded-full px-2 py-0.5 text-gray-600">{cat.count || 0}</span>
            </button>
          ))}
          <button
            onClick={onCreateNew}
            className="w-full flex items-center px-3 py-2 mt-2 text-indigo-600 hover:text-indigo-800 hover:bg-indigo-50 rounded-md text-sm font-medium"
          >
            <PlusIcon className="h-4 w-4 mr-1" /> New Category
          </button>
        </nav>
      )}
    </aside>
  );
};

export default BudgetSidebar;
